import { createFeatureSelector, createSelector } from "@ngrx/store";
import { INotificationState } from "../interfaces/inotification-state";

export const selectNotificationState = createFeatureSelector<INotificationState>('notification');

export const getState = createSelector(selectNotificationState, (state: INotificationState) => state);

